import React from "react"
import ReactDOM from "react-dom"
import "./styles/main.scss"
import App from "./App"
// import ShowCocktail from "./components/ShowCocktail"

ReactDOM.render(<App />, document.getElementById("root"))

